const generateMailtoLink = ({ url, text }) => {
  const bodyText = `${text}\n\n${url}`;
  const params = [
    `subject=${encodeURI(text)}`,
    `body=${encodeURI(bodyText)}`,
  ];
  return `mailto:?${params.join('&')}`;
};

export default generateMailtoLink;
